import { store } from '@betacrew/jars-flux';
import { all, put, takeLeading } from 'redux-saga/effects';
import { componentKey, setAddressInformation, setAddressInformationFieldsTouched, setBasicInformation, setBasicInformationFieldsTouched, setLoadingState, setOptionalInformation, setOptionalInformationFieldsTouched, setPayerCreationSuccessful, setPayerDetailId, setPayerType, setPayerUpdationSuccessful, setSelectedPayer, setUserId, setZipCodeValidationSuccess, setNewlyAddedPayerData } from './AddPayerSlice';
import Payer from "../../../../libs/utility/Payer"
import GeneralDataService from "../../../../services/GeneralDataService"
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import PayerDataService from '../../../../services/PayerDataService';
import { RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } from '../../constants/constants';
import { PAYER_TYPE_1042_S, PAYER_TYPE_TITLE } from './createone/getpayertype/constants';
import { ADD_PAYER_LOADING_STATES, ADD_PAYER_SLICE_INITIAL_STATE, PAYER_SUFFIX_OPTIONS } from './constant';

export const { addSinglePayer, validateZipCode, editPayer, getPayerDataById } = {

    addSinglePayer: (payload) => {
        return {
            type: "NEW/ADD_SINGLE_PAYER",
            payload
        }
    },

    validateZipCode: (payload) => {
        return {
            type: "NEW/VALIDATE_ZIP_CODE",
            payload
        }
    },

    editPayer: (payload) => {
        return {
            type: "NEW/EDIT_PAYER",
            payload
        }
    },

    getPayerDataById: (payload) => {
        return {
            type: "NEW/GET_PAYER_BY_ID",
            payload
        }
    }
}

function* addSinglePayerAsync(action) {

    try {

        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.ADD_SINGLE_PAYER_LOADING }))

        const { PayerType, basicInfo, addressInformation, optionalInformation, zipCodeValidationSuccess, is1042SForm = false } = action.payload;

        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the payer",
                variant: TOASTER_VARIANT.DANGER
            }));

            yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.ADD_SINGLE_PAYER_READY }))

            return;
        }

        const payerData = {
            PayerType: Payer.getPayerType(PayerType),
            FedaralIDType: Payer.getPayerFederalIdType(PayerType, is1042SForm),

            PayerFirstName: basicInfo.PayerFirstName?.value,
            PayerMiddleName: basicInfo.PayerMiddleName?.value,
            PayerLastName: basicInfo.PayerLastName?.value,
            TIN: Payer.removeHyphens(basicInfo.TIN.value),
            PayerEmail: basicInfo.PayerEmail?.value,
            PayerPhNo: basicInfo.PayerPhNo?.value,
            PayerFileType: basicInfo.PayerFileType?.value,
            PayerSuffix: basicInfo.PayerSuffix?.value,

            PayerAddress: addressInformation?.PayerAddress?.value,
            PayerAddress2: addressInformation?.PayerAddress2?.value,
            PayerCountry: addressInformation?.PayerCountry?.value,
            PayerState: addressInformation?.PayerState?.value,
            PayerCity: addressInformation?.PayerCity?.value,
            PayerZIP: addressInformation?.PayerZIP?.value,

            DisregardedEntity: optionalInformation?.DisregardedEntity?.value,
            PayerClientId: optionalInformation?.ClientID?.value,
            UnMaskRecipientTin: optionalInformation?.UnMaskRecipientTIN?.value,
            StateID: optionalInformation?.StateID?.value,
            GroupID: optionalInformation?.GroupID?.value,
        }

        const response = yield PayerDataService.savePayer(payerData);

        if (response.data.Status) {
            yield put(setPayerCreationSuccessful(true))
            yield put(setNewlyAddedPayerData(response.data.Data))
        } else {
            yield put(addNotifications({ heading: "Something went wrong, Failed to add the payer", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        yield put(setPayerCreationSuccessful(false))
        yield put(addNotifications({ heading: "Failed to add the payer", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.ADD_SINGLE_PAYER_READY }))
    }

}

function* validateZipCodeAsync(action) {

    try {
        yield put(setZipCodeValidationSuccess(false));
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING}))

        const { PayerCountry, PayerState, PayerZIP } = action.payload;

        if (PayerCountry?.value !== "US") {
            yield put(setZipCodeValidationSuccess(true));
            yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_READY }))
            return;
        }

        const data = {
            State: PayerState.value,
            ZipCode: PayerZIP.value
        }

        const response = yield GeneralDataService.validateZipCode(data);

        if (response?.data?.Status) {
            yield put(setZipCodeValidationSuccess(true));
        } else {
            yield put(setZipCodeValidationSuccess(false));
            yield put(addNotifications({ heading: "Zip code validation failed", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }


    } catch (error) {
        yield put(setZipCodeValidationSuccess(false));
        yield put(addNotifications({ heading: "Failed to validate the zip code", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_READY }))
    }

}

function* editPayerAsync(action) {

    try {

        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.EDIT_PAYER_LOADING }))

        const { PayerType, basicInfo, addressInformation, optionalInformation, zipCodeValidationSuccess, PayerDetailId, UserId, is1042SForm = false } = action.payload;

        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the payer",
                variant: TOASTER_VARIANT.DANGER
            }));

            yield put(setLoadingState({ state:  ADD_PAYER_LOADING_STATES.EDIT_PAYER_READY }))

            return;
        }

        const payerData = {
            PayerId: PayerDetailId,
            PayerType: Payer.getPayerType(PayerType),
            FedaralIDType: Payer.getPayerFederalIdType(PayerType, is1042SForm),
            TIN: Payer.removeHyphens(basicInfo.TIN.value),
            Userid: UserId,

            PayerFirstName: basicInfo.PayerFirstName?.value,
            PayerMiddleName: basicInfo.PayerMiddleName?.value,
            PayerLastName: basicInfo.PayerLastName?.value,
            PayerEmail: basicInfo.PayerEmail?.value,
            PayerPhNo: basicInfo.PayerPhNo?.value,
            PayerFileType: basicInfo.PayerFileType?.value,
            PayerSuffix: basicInfo.PayerSuffix?.value,

            PayerAddress: addressInformation?.PayerAddress?.value,
            PayerAddress2: addressInformation?.PayerAddress2?.value,
            PayerCountry: addressInformation?.PayerCountry?.value,
            PayerState: addressInformation?.PayerState?.value,
            PayerCity: addressInformation?.PayerCity?.value,
            PayerZIP: addressInformation?.PayerZIP?.value,

            DisregardedEntity: optionalInformation?.DisregardedEntity?.value,
            PayerClientId: optionalInformation?.ClientID?.value,
            UnMaskRecipientTin: optionalInformation?.UnMaskRecipientTIN?.value,
            Stateid: optionalInformation?.StateID?.value,
            GroupID: optionalInformation?.GroupID?.value,
        }

        const response = yield PayerDataService.editPayer(payerData);

        if (response.data.Status) {
            yield put(setPayerUpdationSuccessful(true));
            yield put(addNotifications({ heading: "Success", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }))
        } else {
            yield put(addNotifications({ heading: "Something went wrong, Failed to edit the payer", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        yield put(setPayerUpdationSuccessful(false))
        yield put(addNotifications({ heading: "Failed to edit the payer", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.EDIT_PAYER_READY }))
    }

}

function* getPayerDataByIdAsync({ payload }) {
    try {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.GET_PAYER_DATA_LOADING }));

        const { signedInUser = {}, PayerDetailId, is1042SForm = false, statesList, countriesList } = payload;
        const response = yield PayerDataService.getPayer(PayerDetailId);

        const { Message, Status, Data } = response?.data;

        if (Status) {

            if (is1042SForm) {
                const payerType = PAYER_TYPE_1042_S.find(r => r.value === Data?.IdType);
                if (payerType) {
                    yield put(setPayerType(payerType?.title || ""));
                }
            } else {
                yield put(setPayerType(Data?.IdType === "SSN" ? PAYER_TYPE_TITLE.INDIVIDUAL : PAYER_TYPE_TITLE.BUSINESS))
            }

            yield put(setBasicInformation({
                PayerFirstName: { value: Data?.FirstName || "" },
                PayerMiddleName: { value: Data?.MiddleName || "" },
                PayerSuffix: PAYER_SUFFIX_OPTIONS.find(suf => suf.value === Data.Suffix ) ?? ADD_PAYER_SLICE_INITIAL_STATE.basicInfo.PayerSuffix,
                PayerLastName: { value: Data?.LastName || "" },
                TIN: { value: Data?.IdNumber || "" },
                PayerEmail: { value: Data?.Email || "" },
                PayerPhNo: { value: Data?.PhoneNumber || "" },
            }))

            yield put(setAddressInformation({
                PayerAddress: { value: Data?.Address1 || "" },
                PayerAddress2: { value: Data?.Address2 || "" },
                PayerCity: { value: Data?.City || "" },
            }))

            yield put(setOptionalInformation({
                DisregardedEntity: {
                    value: Data?.DisregardedEntity || "",
                    errors: {},
                    rules: { required: signedInUser?.MultiplePayerLocation ? true : false }
                },
                ClientID: {
                    value: Data?.ClientPayerId || "",
                    errors: {},
                    rules: { required: signedInUser?.IsPayerClient ? true : false, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } }
                },
                UnMaskRecipientTIN: { value: Data?.UnMaskRecipientTin || false },
                StateID: { value: Data?.Stateid || "" },
                // GroupID: { value: Data?.ClientPayerId || "" },
            }))

            yield put(setUserId(Data?.Userid));
            yield put(setPayerDetailId(Data?.PayerDetailId))
            yield put(setBasicInformationFieldsTouched(true))
            yield put(setAddressInformationFieldsTouched(true))
            yield put(setOptionalInformationFieldsTouched(true))
            yield put(setZipCodeValidationSuccess(true))

            const country = countriesList?.find(country => country?.Country_code === Data?.Country)

            let state = { label: Data?.State };
            if (Data?.Country === "US") {
                state = statesList.find(state => state.StateAbbreviation === Data?.State);
            }

            yield put(setAddressInformation({ PayerCountry: country }))
            yield put(setAddressInformation({ PayerState: state }))
            yield put(setAddressInformation({ PayerZIP: { value: Data?.ZipCode || "" } }))

            if (Data?.Country === "US") {
                yield put(setZipCodeValidationSuccess(false))
            } else {
                yield put(setZipCodeValidationSuccess(true))
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch the payer data", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the payer data", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.GET_PAYER_DATA_READY }))
    }
}


function* rootSaga() {
    yield all([
        takeLeading(addSinglePayer().type, addSinglePayerAsync),
        takeLeading(validateZipCode().type, validateZipCodeAsync),
        takeLeading(editPayer().type, editPayerAsync),
        takeLeading(getPayerDataById().type, getPayerDataByIdAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);